/**
 * @flow
 * @relayHash 5e57a328d2c736b5405bb65d904338ad
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddFormToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenFormComponent_addFormToSessionMutationVariables = {|
  input: AddFormToSessionInput
|};
export type OpenFormComponent_addFormToSessionMutationResponse = {|
  +addFormToSession: ?{|
    +form: ?{|
      +id: string
    |}
  |}
|};
export type OpenFormComponent_addFormToSessionMutation = {|
  variables: OpenFormComponent_addFormToSessionMutationVariables,
  response: OpenFormComponent_addFormToSessionMutationResponse,
|};
*/


/*
mutation OpenFormComponent_addFormToSessionMutation(
  $input: AddFormToSessionInput!
) {
  addFormToSession(input: $input) {
    form {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddFormToSessionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addFormToSession",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddFormToSessionInput!"
      }
    ],
    "concreteType": "AddFormToSessionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "form",
        "storageKey": null,
        "args": null,
        "concreteType": "Form",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "OpenFormComponent_addFormToSessionMutation",
  "id": null,
  "text": "mutation OpenFormComponent_addFormToSessionMutation(\n  $input: AddFormToSessionInput!\n) {\n  addFormToSession(input: $input) {\n    form {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "OpenFormComponent_addFormToSessionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "OpenFormComponent_addFormToSessionMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '34ea6e32389965d0423235fee41c5b2d';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Share/__generated__/OpenFormComponent_addFormToSessionMutation.graphql.js